class CartNotification extends HTMLElement {
  constructor() {
    super();
  }

  renderContents(parsedState, cartData) {
      this.getSectionsToRender().forEach((section => {
        const container = document.getElementById(section.id);
        if(container) {
          container.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }));
      this.createEvents(cartData);
  }

  createEvents(cartData) {
    let timer = null;
    let count = 0;
    timer = setInterval(() => {
      if(_learnq) {
        clearInterval(timer);
        const ms = Date.now();
        const fetchHeaders = new Headers({'pragma':'no-cache','cache-control':'no-store','Content-Type':'application/json'});
        let url = '/cart.js?_=' + ms;
        fetch(url,{method: 'GET', headers: fetchHeaders})
            .then((response) => response.json())
            .then((parsedState) => {
              if(parsedState.status && parsedState.message) {
                throw new Error(parsedState.message);
              }
              if(parsedState && parsedState.hasOwnProperty('items') && parsedState.items.length > 0) {
                const responseItem = cartData['responseItem'];
                const discount = (window.partnerDiscount && window.customerIsPartner) ? window.partnerDiscount : window.discount;
                let data = {
                  "$value": parsedState.total_price/100,
                  "AddedItemProductName": responseItem['product_title'],
                  "AddedItemProductID": (responseItem.hasOwnProperty('properties') && responseItem.properties.hasOwnProperty('_id')) ? responseItem.properties['_id'] : responseItem.product_id,
                  "AddedItemSKU": (responseItem.hasOwnProperty('properties') && responseItem.properties.hasOwnProperty('_id')) ? responseItem.properties['_id'] : responseItem.product_id,
                  "AddedItemURL": window.location.href.split('?')[0],
                  "AddedItemQuantity": 1,
                  "AddedItemType": responseItem['product_type']
                };
                const src = this.getCartItemImage(responseItem);
                if(src) {
                  data['AddedItemImageURL'] = src;
                }
                let price = Math.round(responseItem.line_price) / 100;
                if(discount) {
                  price = Math.round(responseItem.original_line_price * (1 - (Number(discount) / 100))) / 100;
                }
                data['AddedItemPrice'] = price;
                let itemNames = [];
                let items = [];
                parsedState.items.forEach((item) => {
                  itemNames.push(item['product_title']);
                  items.push({
                    "ProductID": (item.hasOwnProperty('properties') && item.properties.hasOwnProperty('_id')) ? item.properties['_id'] : item.product_id,
                    "SKU": (item.hasOwnProperty('properties') && item.properties.hasOwnProperty('_id')) ? item.properties['_id'] : item.product_id,
                    "ProductName": item['product_title'],
                    "Quantity": item.quantity,
                    "ItemPrice": discount ? (Math.round(item.original_line_price * (1 - (Number(discount) / 100)))/100) : (Math.round(item.line_price) / 100),
                    "ImageURL": this.getCartItemImage(item),
                    "ProductURL": item.properties['_product_url'],
                    "ItemType": item['product_type']
                  });
                })
                data['ItemNames'] = itemNames;
                data['Items'] = items;
                _learnq.push(['track', 'Added to Cart', data]);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {

            });
      } else {
        count += 1000;
        if (count > 9000) clearInterval(timer);
      }
    },1000);
  }

  getCartItemImage(cartItem) {
    const croppedImage = cartItem.hasOwnProperty('properties') && cartItem.properties.hasOwnProperty('_cropped_image') &&
    cartItem.properties['_cropped_image'] !== '' ? cartItem.properties['_cropped_image'] : null;
    let src = '';
    if(croppedImage) {
      src = croppedImage;
    } else if(cartItem.hasOwnProperty('properties') && cartItem.properties.hasOwnProperty('_canvas_image') &&
        cartItem.properties['_canvas_image'] !== '') {
      src = cartItem.properties['_canvas_image'];
    } else if(cartItem.hasOwnProperty('properties') && cartItem.properties.hasOwnProperty('_original_image') &&
        cartItem.properties['_original_image'] !== '') {
      src = cartItem.properties['_original_image'];
    }
    return src;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-total'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-notification', CartNotification);
